// src/features/monetize/reportRange.ts

import { DateTime } from 'luxon';
import { REPORT_PRESET_DAYS, type REPORT_PRESETS } from '@/lib/constants/monetize';

export type ReportPreset = (typeof REPORT_PRESETS)[number];

/** A preset's whole-UTC-day range ending today, both ends inclusive on the wire. */
export function presetRange(preset: ReportPreset, now: DateTime = DateTime.utc()): { from: string; to: string } {
  const today = now.toUTC().startOf('day');
  return { from: today.minus({ days: REPORT_PRESET_DAYS[preset] - 1 }).toFormat('yyyy-MM-dd'), to: today.toFormat('yyyy-MM-dd') };
}
